/**
 * Define all supported languages here
 */
export interface Localization<ComponentLocalization> {
  /**
   * English
   */
  en: ComponentLocalization;

  /**
   * German
   */
  de: ComponentLocalization;

  /**
   * Swedish
   */
  sv: ComponentLocalization;

  /**
   * Dutch locale for the Netherlands
   */
  nl: ComponentLocalization;

  /**
   * Italian
   */
  it: ComponentLocalization;

  /**
   * Hungarian
   */
  hu: ComponentLocalization;

  /**
   * Danish
   */
  da: ComponentLocalization;

  /**
   * French
   */
  fr: ComponentLocalization;

  /**
   * Spanish
   */
  es: ComponentLocalization;

  /**
   * Polish
   */
  pl: ComponentLocalization;

  /**
   * Romanian
   */
  ro: ComponentLocalization;

  /**
   * Croatian
   */
  hr: ComponentLocalization;

  /**
   * Czech
   */
  cs: ComponentLocalization;

  /**
   * Slovenian
   */
  sl: ComponentLocalization;
}

/**
 * Keep in sync with the above defined interface. These keys will be checked on runtime by setCurrentLocalizationDelegate() function.
 */
export enum LANGUAGE_KEYS {
  en,
  de,
  sv,
  nl,
  it,
  hu,
  da,
  fr,
  es,
  pl,
  ro,
  hr,
  cs,
  sl,
}

export const FALLBACK_LANGUAGE = 'en';
